import { ReminderMailService } from '@/orderTableModule/domains/service/reminderMailService';

/**
 * リマインドメールアイコン関連のComposable
 */
export const useReminderMailIcon = () => {
  /**
   * リマインドメール設定状況に応じて適切なアイコン名を返す
   * @param reminderMailDataId - リマインドメールデータID
   * @returns アイコン名（設定済み: sendMailActiveIcon、未設定: sendMailIcon）
   */
  const getReminderMailIconName = (reminderMailDataId: string | null): string => {
    return ReminderMailService.hasReminderMailSetting(reminderMailDataId) ? 'sendMailActiveIcon' : 'sendMailIcon';
  };

  return {
    getReminderMailIconName,
  };
};
